import React from 'react';

import './ToggleBackText.css';
import { getTranslation } from '../../../assets/creator/translations';

const ToggleBackText = (props) => (
    <div className="toggletext-creator" onClick={props.onClick} style={{display: "flex", cursor: "pointer"}}>
        <span className="toggletext-creator__text">{getTranslation("BackCreatorTextBack")}</span>
    </div>
);

export default ToggleBackText;